// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"NavBar_Navbar__3BOCW","enlaces":"NavBar_enlaces__e4PtZ","fakeLink":"NavBar_fakeLink__3Juel","link":"NavBar_link__2Iixg","linkActive":"NavBar_linkActive__3qOiy"};